import { useCurrentTarget } from './useCurrentTarget';
import { useProjectStore } from '../../../state/projectStore';
import { EmptyState } from '../../ui/EmptyState';
import { t } from '../../../i18n';
import './backgrounds-tab.css';

const SWATCHES = [
  '#ffffff',
  '#f7f4ef',
  '#f0ebe3',
  '#e8e4de',
  '#d8d2c6',
  '#c8beae',
  '#e2eeec',
  '#2f6f6a',
  '#1f1d1a',
  '#3a3632',
];

export function BackgroundsTab() {
  const target = useCurrentTarget();
  const setPageBackground = useProjectStore((s) => s.setPageBackground);

  if (!target) {
    return (
      <div className="left-panel-tab-body">
        <EmptyState title="Selecteer eerst een pagina." />
      </div>
    );
  }

  return (
    <div className="left-panel-tab-body">
      <div className="left-panel-section-title">{t('editor.backgrounds.swatches')}</div>
      <div className="backgrounds-grid">
        {SWATCHES.map((color) => (
          <button
            key={color}
            className="background-swatch"
            style={{ background: color }}
            onClick={() => setPageBackground(target, { type: 'color', color })}
            title={color}
          />
        ))}
        <button
          className="background-swatch none"
          onClick={() => setPageBackground(target, { type: 'none', color: '#ffffff' })}
          title={t('editor.backgrounds.none')}
        >
          Ø
        </button>
      </div>
      <div className="left-panel-section-title">{t('editor.backgrounds.custom')}</div>
      <input
        type="color"
        className="background-custom-input"
        onChange={(e) => setPageBackground(target, { type: 'color', color: e.target.value })}
      />
    </div>
  );
}
